// import React from 'react';
import axios, { AxiosError } from 'axios';

const BASE_URL = 'https://inventariosbackend.velasresorts.com/inventarios/activos';

// El backend no tiene sesión/JWT: usa el UsuarioId ya guardado en sessionStorage
// tras el login para resolver por qué departamento debe filtrar los activos.
const getUsuarioId = (): string | number | undefined => {
    try {
        return JSON.parse(sessionStorage.getItem('user') || '{}')?.Id;
    } catch {
        return undefined;
    }
};

const activosApi = {
    crear: async (data: any) => {
        try {
            const response = await axios.post(`${BASE_URL}/crear`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            return Array.isArray(response.data) ? response.data[0] : response.data;
        } catch (error) {
            console.error('Error fetching informacion de activo:', error);
            return [];
        }
    },

    detalle: async (id: string) => {
        try {
            const response = await axios.get(`${BASE_URL}/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            const axiosError = error as AxiosError;
            if (axiosError.response) {
                console.error('Error response data:', axiosError.response.data);
                console.error('Error response status:', axiosError.response.status);
                console.error('Error response headers:', axiosError.response.headers);
            } else if (axiosError.request) {
                console.error('Error request:', axiosError.request);
            } else {
                console.error('Error message:', axiosError.message);
            }
            return null;
        }
    },

    editar: async (id: string, data: any) => {
        try {
            const response = await axios.put(`${BASE_URL}/editar/${id}`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            const axiosError = error as AxiosError;
            if (axiosError.response) {
                console.error('Error response data:', axiosError.response.data);
                console.error('Error response status:', axiosError.response.status);
                console.error('Error response headers:', axiosError.response.headers);
            } else if (axiosError.request) {
                console.error('Error request:', axiosError.request);
            } else {
                console.error('Error message:', axiosError.message);
            }
            return null;
        }
    },


    listado: async () => {
        try {
            const response = await axios.get(`${BASE_URL}/listado`, {
                params: { usuarioId: getUsuarioId() },
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            return Array.isArray(response.data) ? response.data[0] : response.data;
        } catch (error) {
            console.error('Error fetching activos:', error);
            return [];
        }
    },

    baja: async (id: string) => {
        try {
            const response = await axios.put(`${BASE_URL}/baja/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            return Array.isArray(response.data) ? response.data[0] : response.data;
        } catch (error) {
            console.error('Error fetching informacion de baja de activo:', error);
            return [];
        }
    },
    listadoPorPropiedad: async (hotel: number) => {
        try {
            const response = await axios.get(`${BASE_URL}/listado/${hotel}`, {
                params: { usuarioId: getUsuarioId() },
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            return Array.isArray(response.data) ? response.data[0] : response.data;
        } catch (error) {
            console.error('Error fetching activos:', error);
            return [];
        }
    },
    listadoPorPropiedadSolicitud: async (hotel: number) => {
        try {
            const response = await axios.get(`${BASE_URL}/listado/bajas/${hotel}`, {
                params: { usuarioId: getUsuarioId() },
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            return Array.isArray(response.data) ? response.data[0] : response.data;
        } catch (error) {
            console.error('Error fetching activos:', error);
            return [];
        }
    },
};

export default activosApi;